import styled from 'styled-components/macro';
import { colorCoreBlack300, colorCoreBlack900Base } from '@yme/tokens/colors';
import { ADAPTIVE } from '@yme/tokens/screen';
import { letterSpacingXS, RegularTextLevel5 } from '@yme/tokens/typography';
import { getTextStyles } from '@yme/utils/styles';
export const AmbassadorInfoStyled = styled.div `
  margin-top: 16px;

  ${ADAPTIVE.minWidth.tablet} {
    margin-top: 24px;
  }

  ${ADAPTIVE.minWidth.desktop} {
    flex-grow: 1;
    width: 40%;
    max-width: 546px;
    margin-right: 24px;
    margin-top: 0;
  }
`;
export const SubtitleStyled = styled(RegularTextLevel5) `
  display: block;
  font-weight: 500;
`;
export const TitleStyled = styled.h2 `
  margin: 4px 0 0;

  ${getTextStyles('Play', 700, 24, 28)}
  ${letterSpacingXS}
`;
export const TitleTextStyled = styled.span `
  color: ${colorCoreBlack900Base};
  text-decoration: none;
`;
export const ImageWrapperStyled = styled.div `
  flex-grow: 1;
  width: 100%;

  ${ADAPTIVE.minWidth.desktop} {
    width: 57%;
  }
`;
export const DescriptionStyled = styled.div `
  p {
    ${getTextStyles('Ubuntu', null, 16, 24)};
    color: ${colorCoreBlack300};
  }
`;
